import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo';

const LogoNeutral = (): React.JSX.Element => {
	return <AtlassianLogo appearance="neutral" />;
};

export default LogoNeutral;
